<template>
  <v-layout justify-center align-center>
    <v-flex xs12 sm8 md4>
      <v-card class="elevation-12">
        <v-toolbar dark color="primary">
          <v-toolbar-title>Pixio Admin Login</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <form>
            <v-text-field
              label="Username"
              v-model="username"
              :error-messages="usernameErrors"
              @input="$v.username.$touch()"
              @blur="$v.username.$touch()"
              required
            ></v-text-field>
            <v-text-field
              label="Password"
              v-model="password"
              :error-messages="passwordErrors"
              @input="$v.password.$touch()"
              @blur="$v.password.$touch()"
              :append-icon="e1 ? 'visibility' : 'visibility_off'"
              :append-icon-cb="() => (e1 = !e1)"
              :type="e1 ? 'password' : 'text'"
              required
            ></v-text-field>
            <small>*All fields is required</small>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="submit">Login</v-btn>
        </v-card-actions>
        <v-snackbar
          :timeout="3000"
          :bottom="true"
          :right="true"
          :multi-line="false"
          v-model="snackbar"
        >
          {{ snackbarText }}
          <v-btn flat color="pink" @click.native="snackbar = false">Close</v-btn>
        </v-snackbar>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],
  validations: {
    username: { required, maxLength: maxLength(255) },
    password: { required, maxLength: maxLength(255) }
  },
  data: () => ({
    username: '',
    password: '',
    e1: true,
    snackbarText: 'Input is not valid!',
    snackbar: false
  }),
  computed: {
    usernameErrors () {
      const errors = []
      if (!this.$v.username.$dirty) return errors
      !this.$v.username.maxLength && errors.push('E-mail must be at most 255 characters long')
      !this.$v.username.required && errors.push('E-mail is required')
      return errors
    },
    passwordErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.maxLength && errors.push('Password must be at most 255 characters long')
      !this.$v.password.required && errors.push('Password is required')
      return errors
    }
  },
  methods: {
    submit () {
      this.$v.$touch()
      if (this.$v.$error) {
        this.snackbar = true
        this.snackbarText = 'Input is not valid!'
      } else {
        this.login()
      }
    },
    login: async function () {
      const {username, password} = this
      const res = await this.$store.dispatch('login', {username, password})
      if (res !== 200) {
        this.snackbar = true
        this.snackbarText = 'User not found'
        this.clear()
        return
      }
      this.$router.push('/')
    },
    clear () {
      this.$v.$reset()
      this.password = ''
    }
  }
}
</script>

<style scoped>
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue